// Tableaux historiques dont le découpage par zone passe par un service distinct
// de l'entrée nue (cf. Configurable::ZONE_VARIANTS côté back). La box garde le
// nom nu ; seule la requête réclame la variante « par zones ».
export const ZONE_SPLIT_VARIANTS = {
  MATERIALS_WORK: 'MATERIALS_ZONES_WORK',
  FONCTIONNALITIES_WORK: 'FONCTIONNALITIES_ZONES_WORK',
  PRESTATIONS: 'PRESTATIONS_ZONES_WORK',
  ALL_ARTICLES_WITHOUT_PRICES_WORK: 'ALL_ARTICLES_WITHOUT_PRICES_ZONES_WORK',
  MATERIALS_OPTION_WORK: 'MATERIALS_OPTION_ZONES_WORK',
  FONCTIONNALITIES_OPTION_WORK: 'FONCTIONNALITIES_OPTION_ZONES_WORK',
  PRESTATIONS_OPTION_WORK: 'PRESTATIONS_OPTION_ZONES_WORK',
  ALL_ARTICLES_OPTION_WITHOUT_PRICES_WORK: 'ALL_ARTICLES_OPTION_WITHOUT_PRICES_ZONES_WORK',
};

export const zoneSplitTableName = (tableName) =>
  ZONE_SPLIT_VARIANTS[(tableName || '').toUpperCase()] || tableName;
